import { Activity, Users, ArrowUpRight } from "lucide-react";

/* Elegant dark "product" placeholder built with components (no stock images). */
export default function DashboardMockup() {
  return (
    <div
      data-testid="hero-mockup"
      className="relative rounded-[18px] border border-black/10 bg-gradient-to-b from-black/[0.04] to-transparent p-3 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.14)]"
    >
      {/* window bar */}
      <div className="flex items-center justify-between px-2 py-2">
        <div className="flex items-center gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-black/20" />
          <span className="h-2.5 w-2.5 rounded-full bg-black/15" />
          <span className="h-2.5 w-2.5 rounded-full bg-black/10" />
        </div>
        <span className="font-mono-tech text-[10px] text-tertiary">
          gestionale.local
        </span>
      </div>

      <div className="rounded-[12px] border border-black/10 bg-[var(--ink-900)] p-4">
        {/* top stats */}
        <div className="grid grid-cols-3 gap-3">
          {[
            { label: "Ordini", value: "1.284", icon: Activity },
            { label: "Clienti", value: "342", icon: Users },
            { label: "Fatturato", value: "€ 218k", icon: ArrowUpRight },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-black/[0.08] bg-white p-3"
            >
              <s.icon className="h-4 w-4 text-emerald-600" />
              <div className="mt-2 tabnum text-lg font-semibold text-[color:var(--text-primary)]">
                {s.value}
              </div>
              <div className="text-[11px] text-tertiary">{s.label}</div>
            </div>
          ))}
        </div>

        {/* chart */}
        <div className="mt-4 rounded-lg border border-black/[0.08] bg-black/[0.02] p-4">
          <div className="mb-3 flex items-center justify-between">
            <span className="text-xs text-secondary">Andamento operativo</span>
            <span className="rounded-full bg-emerald-600/12 px-2 py-0.5 text-[10px] font-medium text-emerald-700">
              +18%
            </span>
          </div>
          <div className="flex h-24 items-end gap-1.5">
            {[38, 52, 44, 66, 58, 78, 70, 88, 82, 96, 90, 100].map((h, i) => (
              <div
                key={i}
                className="flex-1 rounded-t bg-gradient-to-t from-emerald-500/25 to-emerald-400/70"
                style={{ height: `${h}%` }}
              />
            ))}
          </div>
        </div>

        {/* rows */}
        <div className="mt-4 space-y-2">
          {[
            ["Preventivo #4821", "Approvato"],
            ["Ordine #9932", "In lavorazione"],
            ["Cliente — Rossi SRL", "Attivo"],
          ].map(([a, b], i) => (
            <div
              key={i}
              className="flex items-center justify-between rounded-md border border-black/[0.06] bg-black/[0.02] px-3 py-2"
            >
              <span className="text-xs text-secondary">{a}</span>
              <span className="flex items-center gap-1.5 text-[11px] text-tertiary">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
                {b}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
